export default "__VITE_ASSET__c7bb7181__"